import { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";
import LottieComponent from "components/core/lottie/lottie-component";
import classnames from "classnames";

import { StyledLottieAnimation } from "./lottie-animation-component.scss";

const VISIBLE_PORTION_OF_ANIMATION = 0.8;

export default class LottieAnimation extends PureComponent {
  constructor(props) {
    super(props);

    this.onVisibilityChange = this.onVisibilityChange.bind(this);

    this.state = {
      isVisible: false,
      reverseAnimation: false,
      animationPlayed: false
    };
  }

  onVisibilityChange(isVisible) {
    this.setState({
      isVisible,
      reverseAnimation: !isVisible,
      animationPlayed: isVisible || this.state.animationPlayed
    });
  }

  shouldPlayAnimation() {
    return this.state.isVisible || this.state.animationPlayed;
  }

  render() {
    const { style, animation, fireActionOnFrame, textColor, aboveTheFold } = this.props;
    const { reverseAnimation, isVisible } = this.state;

    const { playOnlyWhenVisible } = animation;
    const isVisibleOffset = parseInt(style.height) * VISIBLE_PORTION_OF_ANIMATION;

    return (
      <StyledLottieAnimation style={style} color={style.color || textColor} className={classnames("lottie-animation-component", { "above-the-fold": aboveTheFold })}>
        <VisibilitySensor
          offset={{ bottom: isVisibleOffset, top: -10000 }}
          partialVisibility={true}
          onChange={this.onVisibilityChange}
          active={playOnlyWhenVisible}
          scrollCheck={playOnlyWhenVisible}
        >
          <LottieComponent
            {...animation}
            shouldPlay={this.shouldPlayAnimation()}
            reverseAnimation={reverseAnimation}
            fireActionOnFrame={fireActionOnFrame}
            aboveTheFold={aboveTheFold}
          />
        </VisibilitySensor>
      </StyledLottieAnimation>
    );
  }
}

LottieAnimation.defaultProps = {
  style: {
    height: "100px",
    animation: {}
  },

  animation: {
    loop: false,
    autoplay: false,
    playOnlyWhenVisible: true,
    jsonPath: "/static/lottie/arrow-swirl-down.json"
  }
};
